import { useState } from 'react';
import { Modes } from '../types/page-modes';

type PageMode = {
  mode: Modes;
  item?: {
    id: string;
    [key: string]: any;
  };
}

export default function usePageState(): readonly [PageMode, (mode: Modes, item?: any) => void] {
  const [pageState, setPageState] = useState<PageMode>({ mode: Modes.BROWSE });
  return [pageState, (mode: Modes, item?: any): void => setPageState({ mode, item })] as const;
}
